import { Box, Container, Grid, Typography } from "@mui/material";
import SearchCat from "~/images/searchCat.svg";
import { useGetAggregateScoresRefreshInfoQuery } from "~/operations";
import { ScopeType } from "~/hooks/useScope";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { SearchHeader } from "./SearchHeader";

interface NoSearchResultsProps {
  searchQuery: string;
  name: string;
  space?: { id: string; mrn: string; name: string };
  scope?: { type: ScopeType; mrn: string; name: string };
  showSearchInput?: boolean;
}

export function NoSearchResults({
  searchQuery,
  name,
  space,
  scope,
  showSearchInput = false,
}: NoSearchResultsProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [newSearchQuery, setNewSearchQuery] = useState(searchQuery);
  const isSpaceDashboard = scope?.type === ScopeType.Space;

  const { data: refreshInfoData } = useGetAggregateScoresRefreshInfoQuery({
    variables: { groupMrn: space?.mrn || "" },
    skip: !isSpaceDashboard || !space?.mrn,
  });

  const lastUpdatedTime =
    refreshInfoData?.aggregateScoresRefreshInfo.lastUpdatedAt || "";

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    if (newSearchQuery.trim()) {
      const currentParams = new URLSearchParams(searchParams);
      currentParams.set("q", newSearchQuery.trim());
      navigate(`/space/search?${currentParams.toString()}`);
    }
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        pt: 2,
      }}
    >
      {showSearchInput && (
        <SearchHeader
          title={`${scope?.name || name} search results`}
          query={newSearchQuery}
          onQueryChange={setNewSearchQuery}
          onSubmit={handleSearch}
          lastUpdated={isSpaceDashboard ? lastUpdatedTime : undefined}
        />
      )}

      <Grid
        container
        alignItems="center"
        gap={1}
        justifyContent="center"
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <Box
          sx={{
            width: 300,
            height: 300,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={SearchCat}
            alt="Search Cat"
            sx={{ width: 217, height: "auto" }}
          />
        </Box>

        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Typography variant="h5" component="h2" fontWeight={700}>
            No results found
          </Typography>
          <Typography>
            <strong>“{searchQuery}”</strong> did not match any results in {name}
            . Please try again.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
